/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_Tab_YearInputs */

const en_admin_subscriptions_tab_year = /** @type {(inputs: Admin_Subscriptions_Tab_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

const zh_admin_subscriptions_tab_year = /** @type {(inputs: Admin_Subscriptions_Tab_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年付`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Admin_Subscriptions_Tab_YearInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_tab_year = /** @type {((inputs?: Admin_Subscriptions_Tab_YearInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_Tab_YearInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_tab_year(inputs)
	return zh_admin_subscriptions_tab_year(inputs)
});
export { admin_subscriptions_tab_year as "admin.subscriptions.tab_year" }